export var TimesheetSourcePage = /*#__PURE__*/ function(TimesheetSourcePage) {
    TimesheetSourcePage["Approvals"] = "APPROVALS";
    TimesheetSourcePage["MyTimesheet"] = "MY_TIME_SHEET";
    TimesheetSourcePage["TaskPane"] = "TIMEENTRY_TASK_PANE";
    return TimesheetSourcePage;
}({});
